var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',_vm._g(_vm._b({attrs:{"dense":_vm.dense}},'BaseCard',_vm.$attrs,false),_vm.$listeners),[_c('v-card-text',{class:_vm.dense ? 'ma-0 pa-0' : undefined},[_vm._t("content")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }